import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/Globals';
import { HttpService } from 'src/app/services/http-service';
import { getSignupUserId } from '../signup-user';

@Component({
  selector: 'app-reg-driver-assign-vehicle',
  templateUrl: './reg-driver-assign-vehicle.component.html',
  styleUrls: ['./reg-driver-assign-vehicle.component.scss']
})
export class RegDriverAssignVehicleComponent implements OnInit {
  globals = Globals;
  vehicleArray: any[] = [];
  selectedVehicleID: string = null;
  selectedVehicle: any = null;
  driverParams: any = {};
  isLoadingResults = false;

  constructor(private service: HttpService, private router: Router) {}

  ngOnInit() {
    this.driverParams = JSON.parse(localStorage.getItem('driverProfile') || '{}');
    if (this.driverParams.vehicleId) {
      this.selectedVehicleID = this.driverParams.vehicleId;
    }
    this.loadVehicles();
  }

  loadVehicles() {
    this.isLoadingResults = true;
    let url = this.globals.urls.signUp.noauth.fetchVehicles;
    url = url.replace(':limit', '100');
    url = url.replace(':offset', '0');
    const merchantId = getSignupUserId();
    if (merchantId) {
      url += (url.indexOf('?') !== -1 ? '&' : '?') + 'merchantId=' + encodeURIComponent(merchantId);
    }
    this.service.getRequest(url).subscribe(
      res => {
        this.isLoadingResults = false;
        if (res.success === 1) {
          const all = res.data.vehiclesFound || [];
          this.vehicleArray = all.filter((v: any) => !v.isAssigned);
          if (this.selectedVehicleID) {
            this.selectVehicle(this.selectedVehicleID);
          }
        } else {
          this.service.showError(res.message, 'ERROR');
        }
      },
      err => {
        this.isLoadingResults = false;
        this.service.showError(err, 'ERROR');
      }
    );
  }

  selectVehicle(id: string) {
    this.selectedVehicleID = id;
    this.selectedVehicle = null;
    for (let i = 0; i < this.vehicleArray.length; i++) {
      if (this.vehicleArray[i]._id === id) {
        this.selectedVehicle = this.vehicleArray[i];
        break;
      }
    }
  }

  next() {
    if (!this.selectedVehicleID) {
      this.service.showError('Please select a vehicle', 'Error');
      return;
    }
    this.driverParams.vehicleId = this.selectedVehicleID;
    if (this.selectedVehicle) {
      this.driverParams.vehicleName = this.selectedVehicle.vehicleType || this.selectedVehicle.name;
      this.driverParams.vehicleCategory = this.selectedVehicle.vehicleCategory;
      this.driverParams.vehiclePlateNumber = this.selectedVehicle.vehiclePlateNumber;
    }
    localStorage.setItem('driverProfile', JSON.stringify(this.driverParams));
    this.router.navigate(['/registration/drivers/verification']);
  }

  back() {
    this.router.navigate(['/registration/drivers/profile-details']);
  }
}
